import { CheckCircle2, AlertTriangle } from "lucide-react";
import { formatAUD, formatMoney } from "@/lib/format";

const Block = ({ title, block, kind, monthlyLabel }) => (
  <div className="border border-border bg-card" data-testid={`category-block-${kind}`}>
    <div className="px-5 py-3 border-b border-border text-xs uppercase tracking-wider text-muted-foreground">{title}</div>
    <table className="w-full text-sm">
      <tbody>
        {block.rows.map((r) => (
          <tr key={r.id} className="border-b border-border">
            <td className="px-5 py-2">{r.name}</td>
            <td className="px-5 py-2 text-right font-mono" data-testid={`category-amount-${r.id}`}>{formatMoney(r.amount)}</td>
          </tr>
        ))}
        <tr className="border-b border-border bg-amber-500/[0.06]">
          <td className="px-5 py-2 text-amber-300">Uncategorised</td>
          <td className="px-5 py-2 text-right font-mono text-amber-300" data-testid={`category-uncategorised-${kind}`}>{formatMoney(block.uncategorised)}</td>
        </tr>
        <tr className="font-semibold">
          <td className="px-5 py-3">Total</td>
          <td className="px-5 py-3 text-right font-mono" data-testid={`category-total-${kind}`}>{formatAUD(block.total)}</td>
        </tr>
      </tbody>
    </table>
    <Check block={block} kind={kind} monthlyLabel={monthlyLabel} />
  </div>
);

const Check = ({ block, kind, monthlyLabel }) => (
  <div data-testid={`reconciliation-${kind}`}
    className={`flex items-start gap-2 px-5 py-3 text-xs border-t ${block.reconciles ? "border-emerald-500/30 text-emerald-300" : "border-amber-500/40 bg-amber-500/10 text-amber-200"}`}>
    {block.reconciles ? <CheckCircle2 className="h-4 w-4 shrink-0" /> : <AlertTriangle className="h-4 w-4 shrink-0" />}
    <span>
      {block.reconciles
        ? `Reconciles with monthly ${monthlyLabel} (${formatAUD(block.monthly_total)})`
        : `Doesn't reconcile: block ${formatAUD(block.total)} vs monthly ${monthlyLabel} ${formatAUD(block.monthly_total)} (difference ${formatAUD(block.difference)}). Some rows are filed under a category of the other type — use the Ledger filter "Category type mismatch" to find them.`}
    </span>
  </div>
);

export default function CategorySummary({ categories, blankRows }) {
  return (
    <div className="space-y-3">
      {blankRows > 0 && (
        <p className="text-xs text-amber-300" data-testid="category-blank-rows">{blankRows === 1 ? "1 row has" : `${blankRows} rows have`} a blank category and sit in Uncategorised.</p>
      )}
      <div className="grid gap-4 md:grid-cols-2">
        <Block title="Income categories" block={categories.income} kind="income" monthlyLabel="income" />
        <Block title="Expense categories" block={categories.expense} kind="expense" monthlyLabel="expenditure" />
      </div>
    </div>
  );
}
